export default function LoginLogo() {
  return (
    <div className="flex justify-center mb-8">
      <img
        src="/logo-invexis-neon.png"
        alt="Invexis Logo"
        className="h-16 md:h-20 drop-shadow-[0_0_15px_rgba(0,255,255,0.5)]"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = '/logo-invexis.png';
          target.className = 'h-16 md:h-20';
        }}
      />
    </div>
  );
}
